angular.module("avant.smartyStreets", []);
require('./SmartyStreetsService.coffee');
